import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";

import { WrappedNavLink } from "@components/navigation";
import { SportInteractionTypeEnum } from "@data-types/analytics-tracker/SportInteractionTypeEnum";
import { TSection } from "@data-types/offer/live/Section";
import { OfferStoreContext } from "@gp/components";
import { BaseOfferMenuStore as OfferMenuStore } from "@state/stores/offer/shared/BaseOfferMenuStore";
import { analyticsTracker } from "@utils/analytics";
import { slugify } from "@utils/common/slugify";
import classNames from "classnames";
import { observer } from "mobx-react";

import { MenuSportItemButtonCore } from ".";

export const MenuSportItemButton = observer(
	function MenuSportItemButton(props: {
		sportMenuItem: OfferMenuStore["menu"];
	}) {
		const {
			// @ts-expect-error
			toggleSport,
			// @ts-expect-error
			selectedSport,
			// @ts-expect-error
			periodSubMenu: { selectedPeriodKey },
		} = useContext(OfferStoreContext);

		const t = useTranslation().t;

		const { culture, period } = useParams<{
			culture: string;
			period: string;
		}>();

		const isLivePage = useLocation().pathname.includes("/live");

		const sportSlug = slugify(props.sportMenuItem.node.abrv);
		const url = `/${culture}/sports/${period}/f/${sportSlug ?? props.sportMenuItem.node.abrv}`;

		const handleClick = (e: React.MouseEvent) => {
			e.preventDefault();
			if (
				window.location.pathname.includes("live") &&
				selectedSport?.node?.id !== props.sportMenuItem.node.id
			) {
				analyticsTracker.trackSportInteraction(
					SportInteractionTypeEnum.LiveSport,
					props.sportMenuItem.node.abrv
				);
			}
			toggleSport(props.sportMenuItem);
		};

		const buttonClasses = classNames("nav--secondary__link", {
			"is-selected":
				props.sportMenuItem.checkState > 0 &&
				((selectedPeriodKey === TSection.Matches &&
					selectedSport != null) ||
					selectedPeriodKey !== TSection.Matches), // If period on live page is events and selected sport is null we are in all menu and no sport should be selected :{
			"is-expanded":
				selectedSport?.node?.id === props.sportMenuItem.node.id,
		});

		return (
			<li
				className={
					"nav--secondary__item" +
					(props.sportMenuItem.node.isTopTournament
						? " nav--sports__top"
						: " nav--sports__regular")
				}
				data-title={
					props.sportMenuItem.node.isTopTournament
						? t("TOP_TOURNAMENTS.TITLE_MULTI")
						: t("PREMATCH.SUBHEADER.FILTER")
				}
			>
				{isLivePage ? (
					<button
						type="button"
						className={buttonClasses}
						onClick={handleClick}
					>
						<MenuSportItemButtonCore
							sportMenuItem={props.sportMenuItem}
							isSelected={
								props.sportMenuItem.checkState > 0 &&
								((selectedPeriodKey === TSection.Matches &&
									selectedSport != null) ||
									selectedPeriodKey !== TSection.Matches)
							}
						/>
					</button>
				) : (
					<WrappedNavLink
						to={url}
						className={buttonClasses}
						onClick={handleClick}
					>
						<MenuSportItemButtonCore
							sportMenuItem={props.sportMenuItem}
							isSelected={
								props.sportMenuItem.checkState > 0 &&
								((selectedPeriodKey === TSection.Matches &&
									selectedSport != null) ||
									selectedPeriodKey !== TSection.Matches)
							}
						/>
					</WrappedNavLink>
				)}
			</li>
		);
	}
);
